<template>
  <v-dialog v-model="dialog" width="600" class="semi-rounded">
    <v-card color="white" class="px-8 py-12">
      <v-layout
        style="color: var(--primary-color-blue) !important;"
        class="flex-column justify-center align-center title text-center"
      >
        <v-icon color="primary" class="mb-4" style="font-size: 4rem"
          >info</v-icon
        >
        <span class="py-6">{{
          $t("balance_refund.warnign_refundable_balance")
        }}</span>
        <span class="font-weight-bold mb-8">{{
          $t("balance_refund.warnign_balance")
        }}</span>
        <v-btn
          class="py-8 px-10 semi-rounded w-100"
          color="#000230"
          x-large
          @click="dialog = false"
        >
          <span style="color: white;">
            {{ $t("actions.ok") }}
          </span>
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: true,
    };
  },
};
</script>
